import React, { Component } from 'react';
import { COLORS } from '../../theme';
import moment from 'moment';
import { defaultDateFormat, formatMoney } from '../../../lib/util';
import CustomDateRangePicker from '../../../components/custom_date_range';
import ErrorWrapper from '../../../lib/error_wrapper';
import { Table } from 'antd';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Link } from 'react-router-dom';
import DayDifferennceTag from '../../../components/day_difference_tag';

const queryString = require('query-string');

const dt_cols = ({
    query
}) => [
        {
            title: "DATATYPE",
            dataIndex: 'name',
            key: 'datatype'
        },
        {
            title: "Last Transferred",
            dataIndex: 'max_transferred_at',
            key: 'max_transferred_at',
            width: 130,
            render:(value,record)=>{
                return<div style={{
                    display:'flex',
                    justifyContent:'center'
                }}> <DayDifferennceTag date={value}/></div>
            }
        },

        {
            title: "Max txn date",
            dataIndex: 'max_txn_date',
            key: 'max_txn_date',
            width: 130,
            className: 'center-align',
        },
        {
            title:"Source Label",
            dataIndex:'label',
            key:'label'
        },
        {
            title: "Packets in Queue",
            dataIndex: 'packet_count',
            key: 'packet_count',
            className: 'right-align',
            render: (value, data) => {
                return <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end'
                }}>{value > 0 ? <Link to={{
                    pathname: `/activity/data-type/${data.id}/packets/forsource`,
                    search: queryString.stringify({ ...query,source_id:data.label })
                }}>{formatMoney(value, 0)}</Link> :
                    <span className='right-align'>{formatMoney(value, 0)}</span>
                    }</div>


            }
        },
        {
            title: "Txns in Queue",
            dataIndex: 'txn_count',
            key: 'txn_count',
            className: 'right-align',
            render: (value, data) => {
                return <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end'
                }}>{value > 0 ? <Link to={{
                    pathname: `/activity/data-type/${data.id}/nottransferredtransactions`,
                    search: queryString.stringify({ ...query, source_id: data.label })
                }}> <span className='right-align'>{formatMoney(value, 0)}</span></Link> :
                    <span className='right-align'>{formatMoney(value, 0)}</span>
                    }</div>
                //  <Link to={{
                //     pathname:`/activity/data-type/${data.id}/nottransferredtransactions`,
                //     search:queryString.stringify({...query,source:data.label})
                // }}>{formatMoney(value,0)}</Link> 
            }
        },


    ]
class SourceDatatypeList extends Component {
    constructor(props) {
        super(props)

        this.source_id = this.props.source_id;
        this.state = {
            filter_query: {
                // dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                // dateTo: moment().format(defaultDateFormat),
            }
        }
        this.list_extra_infos = RESTExecutor.list().forId(this.source_id).config({
            label: 'source_extra_infos',
            params: {
                ...this.state.filter_query
            }
        }).callbacks(() => { }).connect(props.domains.usergroups);

    }

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }


    render() {
        const { filter_query } = this.state;
        // let list_extra_infos_resp = this.list_extra_infos.response();
        let rowsData = this.props.data_types||[]
        //(list_extra_infos_resp.result && list_extra_infos_resp.result.rows) || []
        return (
            <div
                className='default-card'
                style={{
                    padding: 30,
                    paddingTop:20,
                    paddingBottom:20, 
                    height: '100%',
                    // minHeight:300,
                    margin: 0,
                }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'baseline'
                }}>
                    <span className='sub-heading-1' style={{
                        color: COLORS.secondary
                    }}>Datatypes</span>
{/* 
                    <CustomDateRangePicker
                        style={{
                            width: 200,
                            marginLeft: 16,
                            flex: null
                        }}
                        startDate={moment(filter_query.dateFrom, defaultDateFormat)}
                        endDate={moment(filter_query.dateTo, defaultDateFormat)}
                        onChange={(dates) => {
                            //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                            this.stateUpdater({
                                stateKey: 'filter_query', appendObj: {
                                    dateFrom: dates.startDate.format(defaultDateFormat),
                                    dateTo: dates.endDate.format(defaultDateFormat),
                                },
                                callback: () => {
                                    this.list_extra_infos.config({
                                        params: {
                                            ...filter_query
                                        }
                                    }).execute()
                                }
                            })
                        }}

                    /> */}



                </div>

                <ErrorWrapper
                    onReload={() => {
                        this.list_extra_infos.execute()
                    }}
                >
                    <div 
                    // className='default-card' 
                    style={{
                        margin: 0,
                        padding: 0,
                        marginTop: 16
                    }}>

                        <Table
                            columns={dt_cols({
                                query: {
                                    dateFrom: filter_query.dateFrom,
                                    dateTo: filter_query.dateTo
                                }
                            })}
                            dataSource={rowsData}
                            pagination={false}
                            size='small'
                            className='small-table no-separator-table no-border-table noHover'
                        />


                    </div>
                </ErrorWrapper>
            </div>
        );
    }

    componentDidMount() {
        // this.list_extra_infos.execute()
    }
}

export default withDomains(SourceDatatypeList, "usergroups");
